import { DollarSign } from "lucide-react";
import { Icons } from "../../../assets/icons/Icons";

const InvestmentStats = () => {
    const stats = [
        {
            icon: <Icons.DailyReturnIcon />,
            title: "Daily Returns",
            value: "$49.99",
            subtitle: "USD",
            label: "Today",
        },
        {
            icon: <Icons.MacTokenIcon />,
            title: "MAC Token Balance",
            value: "5,000",
            subtitle: "MAC",
            label: "Today",
        },
        {
            icon: <Icons.DailyReturnIcon />,
            title: "Active Investments",
            value: "$4999",
            subtitle: "Gold Plan",
            label: "Today",
        },
        {
            icon: <Icons.RRewardIcon />,
            title: "Referral Rewards",
            value: "250",
            subtitle: "MAC Earned",
            label: "Status",
        },
        {
            icon: <Icons.LockInIcon />,
            title: "Lock-In Period Remaining",
            value: "25",
            subtitle: "Days",
            label: "Today",
        },
    ];

    return (
        <div className="row g-3 mb-4">
            {stats.map((stat, index) => (
                <div className="col-12" key={index}>
                    <StatCard
                        icon={stat.icon}
                        title={stat.title}
                        value={stat.value}
                        subtitle={stat.subtitle}
                        label={stat.label}
                    />
                </div>
            ))}
        </div>
    );
};

const StatCard = ({ icon, title, value, subtitle, label }) => {
    return (
        <div className="card h-100">
            <div className="card-body p-3">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <div className="rounded-circle me-3 d-flex justify-content-center align-items-center">
                            {icon}
                        </div>
                        <span className="text-secondary">{title}</span>
                    </div>
                    <div className="text-end">
                        <h4 className="text-primary fs-3 fw-bold mb-0 mt-3">
                            {value}
                        </h4>
                        <span className="text-secondary small">{subtitle}</span>
                        <span className="text-secondary small position-absolute top-0 end-0 mt-2 me-3">
                            {label}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvestmentStats;
